var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyWalletBalanceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    fill: "none",
    viewBox: "0 0 28 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#690077",
    d: "M20.02 0c4.599 0 7.313 2.646 7.313 7.176H21.69v.046c-2.618 0-4.74 2.07-4.74 4.622 0 2.553 2.122 4.622 4.74 4.622h5.642v.416c0 4.472-2.714 7.118-7.313 7.118H7.98C3.38 24 .666 21.354.666 16.882V7.118C.666 2.646 3.38 0 7.979 0H20.02zm6.317 9.163c.55 0 .996.435.996.97v3.375a.995.995 0 01-.996.97h-4.54c-1.325.018-2.484-.867-2.784-2.126-.15-.78.06-1.587.577-2.202a2.789 2.789 0 012.101-.987h4.646zm-4.006 1.56h-.438a1.021 1.021 0 00-.72.284.97.97 0 00-.3.698c0 .551.455 1 1.02 1.006h.438c.563 0 1.02-.445 1.02-.994 0-.549-.457-.994-1.02-.994zM14.51 5.188H6.983c-.558 0-1.013.438-1.02.982 0 .551.455 1 1.02 1.006h7.526c.563 0 1.02-.445 1.02-.994 0-.549-.457-.994-1.02-.994z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWalletBalanceIcon);
export default __webpack_public_path__ + "static/media/myWalletBalanceIcon.ecc61ab1932a95dfa37de40bedf8b8cb.svg";
export { ForwardRef as ReactComponent };